module.exports = __webpack_public_path__ + "static/media/benefit5.dc992fba.svg";